import { Component, OnInit, Inject, ElementRef, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShopSettingsService } from '../../modules/general/services/shop-settings.service';

@Component({
  selector: 'app-page-privacy-policy-popup',
  templateUrl: './page-privacy-policy-popup.component.html',
  styleUrls: ['./page-privacy-policy-popup.component.css']
})
export class PagePrivacyPolicyPopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PagePrivacyPolicyPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ref: ElementRef,
    public shopSettingsService: ShopSettingsService,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    if (this.shopSettingsService.isVUMode) {
      this.renderer.addClass(this.ref.nativeElement, 'vu-mode');
    }
  }

  closeClick(): void {
    this.dialogRef.close();
  }

  onCloseClick(): void {
    this.closeClick();
  }

}
